import { FC, HTMLAttributes, JSX, Suspense } from 'react';
import { merge } from '../../../helpers/Utility';
import { Button } from '../button/Button';
import strings from '../shared.translations';
import { AccordionDataOption, AccordionSteps } from './AccordionWizard';
import { Loader } from '../Loader';
import { Loading } from '../Loading';

interface AccordionOptionProps extends HTMLAttributes<HTMLDivElement> {
  option: AccordionDataOption;
  steps: AccordionSteps;
  active: boolean;
  stepCallback: (newStep: number) => void;
  customSubmit: JSX.Element;
}

export const AccordionOption: FC<AccordionOptionProps> = ({
  option,
  steps,
  active,
  stepCallback,
  customSubmit,
  className
}) => {
  return (
    <div className={merge('flex flex-col gap-4 py-4', className)}>
      <p
        className="font-semibold text-lg cursor-pointer"
        onClick={() => {
          stepCallback(steps.currentStep);
        }}
      >
        {option.heading}
      </p>
      {active && (
        <div className="flex flex-col gap-2">
          <Suspense fallback={<Loader className="w-8 h-8 mx-auto my-5" />}>{option.component}</Suspense>
          <div className="flex flex-row gap-4">
            {steps.currentStep !== 0 && (
              <Button
                onClick={() => {
                  stepCallback(steps.currentStep - 1);
                }}
              >
                {strings.previous}
              </Button>
            )}
            {steps.currentStep === steps.totalSteps && <div>{customSubmit}</div>}
            {steps.currentStep !== steps.totalSteps && (
              <Button
                primary
                onClick={() => {
                  stepCallback(steps.currentStep + 1);
                }}
                disabled={option.nextDisabled}
              >
                {strings.next}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
